import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useSnackbarStore } from '@/modules/snackbar/store/useSnackbarStore';

import { useIsLoadTypeBeingUsedCheck } from './useIsLoadTypeBeingUsedCheck';

export const useLoadTypeRemovalGuard = () => {
  const { t } = useTranslation(['interface']);
  const { isLoadTypeBeingUsed } = useIsLoadTypeBeingUsedCheck();
  const { showSnackbar } = useSnackbarStore();

  const showLoadTypeInUseWarning = useCallback(
    () =>
      showSnackbar(
        t('interface:setup.floorPlan.load_carrier_types_select_dialog.warnings.load_type_in_use'),
      ),
    [showSnackbar, t],
  );

  const canRemoveLoadType = useCallback(
    (id: string): boolean => {
      if (!isLoadTypeBeingUsed(id)) {
        return true;
      }

      showLoadTypeInUseWarning();
      return false;
    },
    [isLoadTypeBeingUsed, showLoadTypeInUseWarning],
  );

  const canRemoveLoadTypes = useCallback(
    (ids: string[]): boolean => ids.every(canRemoveLoadType),
    [canRemoveLoadType],
  );

  return {
    canRemoveLoadType,
    canRemoveLoadTypes,
  };
};
